import { render, staticRenderFns } from "./PortfolioManagerTable.vue?vue&type=template&id=79f994d7&scoped=true&"
import script from "./PortfolioManagerTable.vue?vue&type=script&lang=ts&"
export * from "./PortfolioManagerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f994d7",
  null
  
)

export default component.exports